<template lang="pug">
.cp-num
  .fix
    .num.fl(ref="num", v-for="v in numList")
</template>
<script>
export default {
  components: {},
  props: {
    num: {
      type: Number
    },
    targetNum: {
      type: String
    }
  },
  data () {
    return {
      numList: this.targetNum.split('')
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    changeNum (num) {
      const fixList = this.getFixedList(num)
      fixList.forEach((v, index) => {
        const num = this.$refs.num[index]
        const offsetY = -48 * v
        num.style.backgroundPosition = `50% ${offsetY}px`
      })
    },
    getFixedList (num) {
      let list = String(num).split('')
      const diffLength = this.targetNum.length - list.length
      if (diffLength > 0) {
        list = Array(diffLength).fill(0).concat(list)
      }
      return list
    }
  }
}
</script>
<style lang="stylus">
.cp-num
  .num
    width 25px
    height 47px
    background-image url('../assets/nums.png')
    background-position 50% 0px
    background-size 39px 478px
    background-repeat no-repeat
</style>
